import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { alertActions } from "_store";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  getEAAgenciesApi,
  createEAAgencyApi,
  updateEAAgencyApi,
  deleteEAAgencyApi,
} from "services/energyAssistance/energyAssistance.thunks";
import AgencyCreate from "../../components/AgencyCreate";
import ManageAgencyTable from "../../components/AgencyTable";
import { ERR_MSG } from "constants/labels";

const ManageEAAgency = () => {
  const header = "Manage EA Agency";
  const dispatch = useDispatch();
  const [rawTableData, setRawTableData] = useState([]);

  const fetchAgencies = async () => {
    try {
      const res = await dispatch(getEAAgenciesApi()).unwrap();
      if (!res || !res?.Succeeded) {
        dispatch(
          alertActions.error({
            message: res?.Message || ERR_MSG["073"],
            header,
          }),
        );
        return;
      }
      setRawTableData(res?.Data || []);
    } catch (error) {
      dispatch(
        alertActions.error({
          message: error.message ? ERR_MSG["073"] : error,
          header,
        }),
      );
    }
  };

  useEffect(() => {
    fetchAgencies();
  }, []);

  return (
    <>
      <Typography component="div" className="userprofilelist">
        <Grid container direction="row" spacing={2}>
          <Grid size={{ xs: 12, sm: 12, md: 4 }}>
            <Typography variant="h2" className="userprofilelistcontent">
              {header}
            </Typography>
          </Grid>
        </Grid>
      </Typography>
      <Grid container justifyContent={"flex-end"} alignItems={"center"}>
        {rawTableData && (
          <AgencyCreate
            agencies={rawTableData}
            handleRefresh={fetchAgencies}
            createApi={createEAAgencyApi}
            header={header}
            title="Create EA Agency"
            buttonLabel="Agency"
            portalID={2}
          />
        )}
      </Grid>
      <Typography component="div">
        {rawTableData && (
          <ManageAgencyTable
            portalID={2}
            rawTableData={rawTableData}
            handleRefresh={fetchAgencies}
            updateApi={updateEAAgencyApi}
            deleteApi={deleteEAAgencyApi}
            header={header}
            emptyMessage="No EA agency data found."
          />
        )}
      </Typography>
    </>
  );
};

export default ManageEAAgency;
